import React from 'react';
import { get, filter, isEmpty } from 'lodash';
import { DateUtil } from 'utils/DateUtil';

const mapBanner = (response, mediaPath) => {
  const venues = response.music_event_venues.map(venue => {
    return extractVenues(venue);
  });
  const genres = response.music_event_genres.map(genre => {
    return extractGenres(genre);
  });
  const title =
    response.music_event_details && response.music_event_details[0].event_name;
  const description =
    response.music_event_details &&
    response.music_event_details[0].event_description;
  const event_poster = `${mediaPath.web}/${response.event_poster}`;
  const poster_mobile = `${mediaPath.mobile}/${response.mobile_image}`;
  const thumbnail = `${mediaPath.thumbnail}/${response.event_poster}`;
  const videoUrl = response.event_video ? response.event_video : null;
  const standing_capacity = get(
    response.music_event_venues[0],
    'restaurant_outlet.standing_capacity',
    ''
  );
  const standing_ticket_price = response.standing_ticket_price;
  const seating_ticket_price = response.seating_ticket_price;

  return {
    title,
    description,
    event_poster,
    poster_mobile,
    thumbnail,
    venues,
    genres,
    videoUrl,
    standing_capacity,
    seating_ticket_price,
    standing_ticket_price,
  };
};

const mapEventArtist = (response, artistMediaPath) => {
  let artist_collection = [];
  response.music_event_artists.map((artist_data, idx) => {
    artist_collection.push(mapArtistData(artist_data, artistMediaPath));
  });
  return artist_collection;
};

const mapArtistData = (artist, artistMediaPath) => {
  let artist_data = artist.artist;
  let videos = [];
  let artistIntro = {
    artist_id: artist.artist_id,
    heading: 'About',
    subHeading: get(artist_data, 'artist_details[0].artist_name', ''),
    artist_image: `${artistMediaPath}Web/${artist_data.artist_picture}`,
    artist_image_mobile: artist_data.artist_mobile_picture
      ? `${artistMediaPath}Mobile/${artist_data.artist_mobile_picture}`
      : `${artistMediaPath}Web/${artist_data.artist_picture}`,
    paragraph: get(artist_data, 'artist_details[0].artist_description', ''),
    paragraphMobile: get(
      artist_data,
      'artist_details[0].artist_mobile_description',
      ''
    ),
    artist_website_url: get(artist_data, 'artist_website', ''),
    artist_button_name: get(artist_data, 'artist_details[0].button_name', ''),
    artist_button_link: get(artist_data, 'artist_details[0].button_link', ''),
    artist_website_label: get(
      artist_data,
      'artist_details[0].website_label',
      ''
    ),
  };

  videos = mapArtistVideos(artist_data.artist_videos);

  return {
    artistIntro,
    videos,
  };
};

const mapArtistVideos = videos_data => {
  if (videos_data.length === 0) return [];
  let videos = [];
  videos_data.map(video_data => {
    videos.push(mapVideoForArtist(video_data));
  });
  return videos;
};

const mapVideoForArtist = video_data => {
  const area = get(video_data, 'area.area_name', '');
  const city = get(video_data, 'city.city_name', '');
  const locationType = video_data.location_type;
  return {
    name: video_data.title,
    description: video_data.description,
    description_mobile: video_data.mobile_description,
    videoUrl: video_data.link,
    videoThumbNail: get(video_data, 'thumbnail_url', ''),
    venue:
      locationType === 'Others'
        ? video_data.other_venue
        : get(video_data, 'restaurant_outlet.outlet_name', ''),
    location: `${area}, ${city}`,
    city: city,
    date: DateUtil.getDisplayDateFromISOString(video_data.event_date),
  };
};

const extractGenres = data => {
  return get(data, 'genre.genre_name', '');
};

const extractVenues = data => {
  const area = get(data, 'area.area_name', '');
  const city = get(data, 'city.city_name', '');
  const locationType = data.location_type;
  const eventDates = data.music_event_dates;
  const name =
    locationType === 'Restaurant'
      ? get(data, 'restaurant_outlet.outlet_name', '')
      : data.other_venue;
  const outlet_id = get(data, 'restaurant_outlet_id', '');

  return {
    location: `${area}, ${city}`,
    locationType,
    eventDates,
    name,
    outlet_id,
  };
};

const mapOutletSeating = response => {
  if (isEmpty(response)) return [];
  let tables = [];
  response.map(table => {
    tables.push(createOutletSeatingTable(table));
  });
  const firstRow = filterTables(tables, 61, 65);
  const secondRow = filterTables(tables, 51, 55);
  const thirdRow = filterTables(tables, 41, 45);
  const fourthRow = filterTables(tables, 31, 35);
  const fifthRow = filterTables(tables, 21, 25);
  const cornerRow = filterTables(tables, 74, 75);
  return {
    firstRow: firstRow,
    secondRow: secondRow,
    thirdRow: thirdRow,
    fourthRow: fourthRow,
    fifthRow: fifthRow,
    cornerRow: cornerRow,
  };
};

const createOutletSeatingTable = tableData => {
  const { id, seating_capacity, table_number } = tableData;
  let table_className = '';
  if (
    table_number === 21 ||
    table_number === 31 ||
    table_number === 41 ||
    table_number === 51 ||
    table_number === 61
  )
    table_className = 'table-1 table-image';
  if (
    table_number === 22 ||
    table_number === 32 ||
    table_number === 42 ||
    table_number === 52 ||
    table_number === 62
  )
    table_className = 'table-2 table-image';
  if (
    table_number === 23 ||
    table_number === 33 ||
    table_number === 43 ||
    table_number === 53 ||
    table_number === 63
  )
    table_className = 'table-3 table-image';
  if (
    table_number === 24 ||
    table_number === 34 ||
    table_number === 44 ||
    table_number === 54 ||
    table_number === 64
  )
    table_className = 'table-4 table-image';
  if (
    table_number === 25 ||
    table_number === 35 ||
    table_number === 45 ||
    table_number === 55 ||
    table_number === 65
  )
    table_className = 'table-5 table-image';
  if (table_number === 75) table_className = 'corner-table-1 table-image';
  if (table_number === 74) table_className = 'corner-table-2 table-image';
  return {
    id,
    table_number,
    capacity: seating_capacity,
    booked: false,
    imageSelected: false,
    className: table_className,
  };
};

const filterTables = (tables, initial_number, final_number) => {
  return filter(
    tables,
    tableItem =>
      tableItem.table_number >= initial_number &&
      tableItem.table_number <= final_number
  );
};

export const EventDetails = {
  mapBanner,
  mapEventArtist,
  mapOutletSeating,
};
